export default __webpack_public_path__ + "static/media/moving-company-logo-01.593947d4.png";